// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-acknowledge-conatiners {
  background-color: #fff;
  width: 493px;
  height: 292px;
}
.popup-acknowledge-conatiners .popupackfirst-para-span {
  font-family: Nunito;
  font-size: 20px;
  font-weight: 600;
  color: #0c3688;
  margin: 2rem;
}
.popup-acknowledge-conatiners .popuack-second-para {
  font-family: Nunito;
  font-size: 14px;
  font-weight: 700;
  margin: 2rem;
}
.popup-acknowledge-conatiners .text-area-box {
  width: 27rem;
  height: 6.4rem;
  margin: 0.5rem 2rem;
  resize: none;
}
.popup-acknowledge-conatiners .popupackconatiners-img {
  float: right;
  display: flex;
  justify-content: end;
  margin: 1rem;
}
.popup-acknowledge-conatiners .popup-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: 0.5rem 2rem;
  width: 80%;
  margin: auto;
  margin-top: 15px;
}
.popup-acknowledge-conatiners .cancel-buttons-pop {
  color: #fff;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  font-family: Nunito;
  font-size: 16px;
  font-weight: 700;
  border-radius: 5px;
  border: none;
  width: 10rem;
  height: 2.7rem;
}
.popup-acknowledge-conatiners .img-para {
  margin: 0.5rem;
  display: flex;
  justify-content: end;
}
.popup-acknowledge-conatiners .acknowledge-buttons-pop:disabled,
.popup-acknowledge-conatiners .acknowledge-buttons-pop:disabled:hover {
  font-family: Nunito;
  font-size: 16px;
  font-weight: 700;
  background: #5ccb96;
  color: white;
  border: none;
  width: 60%;
  height: 2.7rem;
  border-radius: 5px;
}
.popup-acknowledge-conatiners .acknowledge-buttons-pop {
  font-family: Nunito;
  font-size: 16px;
  font-weight: 700;
  background: #00b55e;
  width: 60%;
  color: white;
  border: none;
  border-radius: 5px;
  height: 2.7rem;
}
.popup-acknowledge-conatiners .loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 6vh !important;
}
.popup-acknowledge-conatiners .loader-container .loader {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 2s linear infinite;
}

@media screen and (max-width: 480px) {
  .popupackconatiners {
    width: 100%;
  }
  .modal-content {
    width: 80%;
  }
  .popupackconatiners {
    width: 100% !important;
    margin: auto;
  }
  .text-area-box {
    width: 80% !important;
    margin: auto;
  }
  .cancel-buttons-pop {
    font-size: 12px !important;
    width: fit-content !important;
  }
  .acknowledge-buttons-pop {
    font-size: 12px !important;
    width: fit-content !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/PopupAck/acknowledgePopup.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,YAAA;EACA,aAAA;AACF;AACE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AACJ;AACE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AACJ;AACE;EACE,YAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AACJ;AAEE;EACE,YAAA;EACA,aAAA;EACA,oBAAA;EACA,YAAA;AAAJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAAJ;AAEE;EACE,WAAA;EACA,mEAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AAAJ;AAEE;EACE,cAAA;EACA,aAAA;EACA,oBAAA;AAAJ;AAEE;;EAEE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AAAJ;AAEE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAAJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAAJ;AACI;EACE,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AACN;;AAGA;EACE;IACE,WAAA;EAAF;EAEA;IACE,UAAA;EAAF;EAEA;IACE,sBAAA;IACA,YAAA;EAAF;EAEF;IACE,qBAAA;IACA,YAAA;EAAA;EAEF;IACE,0BAAA;IACA,6BAAA;EAAA;EAEF;IACE,0BAAA;IACA,6BAAA;EAAA;AACF","sourcesContent":[".popup-acknowledge-conatiners {\n  background-color: #fff;\n  width: 493px;\n  height: 292px;\n\n  .popupackfirst-para-span {\n    font-family: Nunito;\n    font-size: 20px;\n    font-weight: 600;\n    color: #0c3688;\n    margin: 2rem;\n  }\n  .popuack-second-para {\n    font-family: Nunito;\n    font-size: 14px;\n    font-weight: 700;\n    margin: 2rem;\n  }\n  .text-area-box {\n    width: 27rem;\n    height: 6.4rem;\n    margin: 0.5rem 2rem;\n    resize: none;\n  }\n\n  .popupackconatiners-img {\n    float: right;\n    display: flex;\n    justify-content: end;\n    margin: 1rem;\n  }\n  .popup-button-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    margin: 0.5rem 2rem;\n    width: 80%;\n    margin: auto;\n    margin-top: 15px;\n  }\n  .cancel-buttons-pop {\n    color: #fff;\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    font-family: Nunito;\n    font-size: 16px;\n    font-weight: 700;\n    border-radius: 5px;\n    border: none;\n    width: 10rem;\n    height: 2.7rem;\n  }\n  .img-para{\n    margin: 0.5rem;\n    display: flex;\n    justify-content: end;\n  }\n  .acknowledge-buttons-pop:disabled,\n  .acknowledge-buttons-pop:disabled:hover{\n    font-family: Nunito;\n    font-size: 16px;\n    font-weight: 700;\n    background: #5ccb96;\n    color: white;\n    border: none;\n    width: 60%;\n    height: 2.7rem;\n    border-radius: 5px;\n  }\n  .acknowledge-buttons-pop {\n    font-family: Nunito;\n    font-size: 16px;\n    font-weight: 700;\n    background: #00b55e;\n    width: 60%;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    height: 2.7rem;\n  }\n  .loader-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 6vh !important;\n    .loader {\n      border: 3px solid #f3f3f3;\n      border-top: 3px solid #3498db;\n      border-radius: 50%;\n      width: 35px;\n      height: 35px;\n      animation: spin 2s linear infinite;\n  }\n  }\n}\n@media screen and (max-width:480px) {\n  .popupackconatiners{\n    width: 100%;\n  }\n  .modal-content{\n    width: 80%;\n  }\n  .popupackconatiners {\n    width: 100% !important;\n    margin: auto;\n}\n.text-area-box{\n  width: 80% !important;\n  margin: auto;\n}\n.cancel-buttons-pop{\n  font-size: 12px !important;\n  width: fit-content !important;\n}\n.acknowledge-buttons-pop{\n  font-size: 12px !important;\n  width: fit-content !important;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
